import { useState } from 'react'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import utc from 'dayjs/plugin/utc'

import { PatientProfileFormData } from '@/features/patient/patient-profile-form'
import { getGenderFromInsNIR, insSexToPatientGender } from '@/utils/patient'

import { DMPConnectVitaleCardPatient } from './types'

dayjs.extend(customParseFormat)
dayjs.extend(utc)

export function useSelectVitaleCardInfo() {
  const [vitaleCardInfo, setVitaleCardInfo] = useState<Partial<PatientProfileFormData>>({})

  const onPlatformVitaleCardSelect = (info: Partial<PatientProfileFormData>) => {
    const newInfo = { ...info }
    if (newInfo.birthday) {
      newInfo.birthday = new Date(newInfo.birthday.getTime() - newInfo.birthday.getTimezoneOffset() * 60000)
    }
    setVitaleCardInfo(newInfo)
  }

  const onDMPConnectVitaleCardSelect = (patient: DMPConnectVitaleCardPatient) => {
    const { insIdentity } = patient
    const insOID = insIdentity?.Ins.s_oid
    const insSex = insIdentity?.i_sex
    setVitaleCardInfo({
      name: insIdentity?.s_given || patient.s_given,
      birthName: insIdentity?.s_birthGiven,
      surname: patient.s_name,
      birthSurname: insIdentity?.s_birthName || patient.s_birthname,
      insNIR: {
        value: insIdentity?.Ins.s_value || '',
        key: insIdentity?.Ins.s_key || '',
      },
      insOID,
      secu: patient.s_nir.replaceAll(' ', ''),
      birthday: dayjs.utc(patient.s_birthdayYYYYMMDD, 'YYYYMMDD', true).toDate(),
      birthPlaceCode: insIdentity?.s_birthPlace,
      gender: insSex ? insSexToPatientGender(insSex) : patient.s_certifiedNir ? getGenderFromInsNIR(patient.s_certifiedNir) : 'I',
      codeGestion: patient.HealthCoverage.s_center,
      codeRegime: patient.HealthCoverage.s_regime,
      caisse: patient.HealthCoverage.s_desk,
    })
  }

  return {
    vitaleCardInfo,
    onDMPConnectVitaleCardSelect,
    onPlatformVitaleCardSelect,
  }
}
